import {
Component,
ElementRef,
Inject,
InjectionToken,
OnInit,
ViewChild,
} from '@angular/core';
import {
FormBuilder
} from '@angular/forms';
import { ActivatedRoute,Router } from '@angular/router';

import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { MatList,MatListModule } from '@angular/material/list';
import { RouterLink } from '@angular/router';
import { distinct } from 'rxjs';
import { PrettySize } from '../../pipes';
import {
ErrorServiceToken,
LogServiceToken,
MapperServiceToken,
ProgressService,
ProgressServiceToken,
RepositoryServiceToken,
} from '../../services';
import {
IErrorService,
ILogService,
IMapperService,
IRepositoryService,
} from '../../services/i';
import {
CorrespondenceDocumentViewModel,
CorrespondenceViewModel,
DocumentViewModel,
ReviewDocumentViewModel,
ReviewViewModel
} from '../../view-models';
import { HeaderComponent } from '../header/header.component';

@Component({
  selector: 'app-add-document',
  templateUrl: './add-document.component.html',
  imports: [
    HeaderComponent,
    MatListModule,
    RouterLink,
    MatCheckboxModule,
    MatList,
    MatInputModule,
    CommonModule,
    MatButtonModule,
    PrettySize,
  ],
  styleUrls: ['./add-document.component.css'],
  standalone: true,
})
export class AddDocumentComponent implements OnInit {
  @ViewChild('fileChooserForm') chooser: ElementRef;
  @ViewChild('fileInput') fileInput: ElementRef;
  computedTitle: string;
  whoAmI: InjectionToken<any> = new InjectionToken('AddDocumentComponent');
  mode = 'correspondence';
  cvm: CorrespondenceViewModel;
  rvm: ReviewViewModel;
  documents: File[] = [];
  // tslint:disable-next-line:no-bitwise
  maxRequestLength = 30 * (1 << 20);
  size = 0;
  disabled = false;
  percentComplete = 0;
  percentCompleteDisplay = '0%';
  fontRefs = {
    'image/png': 'fa-file-picture-o',
    'image/gif': 'fa-file-picture-o',
    'image/jpeg': 'fa-file-picture-o',
    'application/pdf': 'fa-file-pdf-o',
    'application/excel': 'fa-file-excel-o',
    'application/msword': 'fa-file-word-o',
    'text/plain': 'fa-file-text',
  };

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    @Inject(ErrorServiceToken) private errors: IErrorService,
    @Inject(ProgressServiceToken) private progress: ProgressService,
    @Inject(MapperServiceToken) private mapper: IMapperService,
    @Inject(RepositoryServiceToken) private repo: IRepositoryService,
    @Inject(LogServiceToken) private log: ILogService
  ) {
    this.computedTitle =
      'Add Documents to ' +
      (this.mode === 'correspondence' ? 'Correspondence' : 'Review');
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      const id = +params['id'] || +params['cid'];
      const rid = +params['rid'];
      if (id) {
        this.repo
          .Get(CorrespondenceViewModel, id)
          .toPromise()
          .then(corr => {
            this.cvm = corr;
            if (this.mode === 'correspondence' && corr && corr.Title) {
              this.computedTitle += ` '${corr.Title.substr(0, 30).trim()}...'`;
            }
          });
        if (rid) {
          this.mode = 'review';
          this.repo
            .Get(ReviewViewModel, rid)
            .toPromise()
            .then(r => {
              this.rvm = r;
              if (this.mode !== 'correspondence' && r && r.ReviewText) {
                this.computedTitle += ` '${r.ReviewText.substr(0, 30).trim()}...'`;
              }
            });
        }
      } else {
        this.errors.broadcast(
          'Error',
          this.whoAmI,
          'Internal application error. Please report.'
        );
      }
    });

    this.progress.progressEventObservable
      .pipe(distinct(e => e.loaded)).subscribe(
      (e: ProgressEvent) => {
        this.log.log('Progress', e.loaded, e.total, e);
        if (e.total > 0) {
          this.percentComplete = (e.loaded / e.total) * 100;
          const p = '' + Math.round(this.percentComplete * 10) / 10;
          const i = p.indexOf('.');
          this.percentCompleteDisplay = i > -1 ? p.substr(0, i + 2) : p;
        }
      },
      e => {
        this.disabled = false;
        this.errors.broadcast(
          'Error',
          this.whoAmI,
          'Unknown error during upload. Please retry or contact support.'
        );
      }
    );
  }
  get Id() {
    return this.mode === 'correspondence' ? this.cvm.Id : this.rvm.Id;
  }

  fileChangeEvent($event) {
    const files = <FileList>$event.target.files;
    for (let i = 0; i < files.length; i++) {
      if (!this.fontRefs[files[i].type]) {
        this.log.warn('Could not find filetype: ' + files[i].type, files[i]);
        files[i]['iconRef'] = 'fa-file-o';
      } else {
        files[i]['iconRef'] = this.fontRefs[files[i].type];
      }
      files[i]['selected'] = true;
      this.documents.push(files[i]);
    }
    this.updateMetrics();
    this.chooser.nativeElement.reset();
  }

  updateMetrics() {
    this.size = this.documents
      .filter((d: File) => d['selected'])
      .reduce((s: number, d: File) => (d['selected'] ? d.size + s : s), 0);
  }

  removeFileFromUpload(file: File) {
    const i = this.documents.indexOf(file);
    this.documents.splice(i, 1);
    this.updateMetrics();
  }

  clearUnselectedFromUpload() {
    const tempDocs = [];
    for (let i = 0; i < this.documents.length; i++) {
      if (this.documents[i]['selected']) {
        tempDocs.push(this.documents[i]);
      }
    }
    this.documents = tempDocs;
    this.updateMetrics();
  }

  toggleFile(i: number) {
    const doc = this.documents[i];
    doc['selected'] = !doc['selected'];
    this.updateMetrics();
  }

  clickActualButtonLOL() {
    const event = new MouseEvent('click', { bubbles: true });
    this.fileInput.nativeElement.dispatchEvent(event);
  }

  uploadFiles() {
    this.clearUnselectedFromUpload();
    if (this.documents.length === 0 || this.size > this.maxRequestLength) {
      return;
    }

    this.disabled = true;
    let count = 0;
    const form = this.documents.reduce((formTemp: FormData, cur: File) => {
      count = count + 1;
      formTemp.append('files', cur, cur.name);
      return formTemp;
    }, new FormData());
    const promise = this.repo.CreateMany(DocumentViewModel, form).toPromise();
    promise.catch(e => {
      this.disabled = false;
      this.errors.broadcast(
        'Error',
        this.whoAmI,
        'Unknown error during upload. Please retry or contact support.'
      );
    });
    if (this.mode === 'correspondence') {
      promise
        .then((docs: DocumentViewModel[]) => {
          const vms = docs.map(d =>
            this.mapper.MapJsonToVM(CorrespondenceDocumentViewModel, {
              CorrespondenceId: this.cvm.Id,
              DocumentId: d.Id,
            })
          );
          return this.repo
            .CreateMany(CorrespondenceDocumentViewModel, vms)
            .toPromise();
        })
        .then(
          (cdvms: CorrespondenceDocumentViewModel[] | ReviewViewModel[]) => {
            this.router.navigate(['/correspondence', this.cvm.Id]);
          }
        )
        .catch(e => {
          this.disabled = false;
          this.errors.broadcast(
            'Error',
            this.whoAmI,
            'Unknown error during upload. Please retry or contact support.'
          );
        });
    } else if (this.mode === 'review') {
      promise
        .then((docs: DocumentViewModel[]) => {
          this.log.debug(this.rvm);
          const vms = docs.map(d =>
            this.mapper.MapJsonToVM(ReviewDocumentViewModel, <
              ReviewDocumentViewModel
            >{ ReviewId: this.rvm.Id, DocumentId: d.Id })
          );
          return this.repo.CreateMany(ReviewDocumentViewModel, vms).toPromise();
        })
        .then((cdvms: ReviewDocumentViewModel[]) => {
          this.router.navigate([
            '/correspondence',
            this.cvm.Id,
            'reviews',
            this.rvm.Id,
          ]);
        })
        .catch(e => {
          this.disabled = false;
          this.errors.broadcast(
            'Error',
            this.whoAmI,
            'Unknown error during upload. Please retry or contact support.'
          );
        });
    }
  }
}
